import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { sanityClient } from "../lib/sanityClient";

// ArticleCard Component
const ArticleCard = ({ article }) => {
  return (
    <div className="border rounded-lg p-4 shadow-md">
      {article.primaryImage && (
        <img
          src={article.primaryImage}
          alt={article.title}
          className="w-full h-48 object-cover rounded-md"
        />
      )}
      <h2 className="text-xl font-semibold mt-2">{article.title}</h2>
      <p className="text-sm text-gray-600">By {article.author} | {new Date(article.publishedAt).toDateString()}</p>
      <Link to={`/articles/${article.slug.current}`} className="text-blue-500 mt-2 block">Read More</Link>
    </div>
  );
};

// ArticlesList Component
const ArticlesList = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const query = `*[_type == "article"]{ _id, title, slug, publishedAt, author, primaryImage }`;
        const data = await sanityClient.fetch(query);
        setArticles(data);
      } catch (error) {
        console.error("Error fetching articles:", error);
      }
    };
    fetchArticles();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {articles.map((article) => (
        <ArticleCard key={article._id} article={article} />
      ))}
    </div>
  );
};

// ArticlesPage Component
const ArticlesPage = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Latest Articles</h1>
      <ArticlesList />
    </div>
  );
};

export default ArticlesPage;
